export const SchemaRequired = {
  title: "",
  type: "",
  category: "",
  private: "",
  make: "",
  model: "",
};

export const SchemaOptional = {
  gallery: "",
  body: "",
};

export const types = [
  {
    key: "technical",
    label: "Technical",
  },
	{
    key: "mod",
    label: "Modification",
  },
  {
    key: "general",
    label: "General",
  },
];

export const categories = [
  {
    type: "technical",
    items: [
      {
        key: "diagram",
        label: "Diagram",
      },
			{
        key: "specification",
        label: "Specification",
      },
      {
        key: "other",
        label: "Other",
      },
    ],
  },
  {
    type: "mod",
    items: [
      {
        key: "performance",
        label: "Performance",
      },
      {
        key: "visual",
        label: "Visual",
      },
			{
        key: "other",
        label: "Other",
      },
    ],
  },
  {
    type: "general",
    items: [
			{
        key: "other",
        label: "Other",
      },
		],
  },
];